import { IFRAME_BASE_PATH } from 'router/utils/iframe';

export const iframeAddCustomerQuotePath = () => `${IFRAME_BASE_PATH}/quote/customer/add`;
export const iframeAddPartBomPath = () => `${IFRAME_BASE_PATH}/part-bom/add`;
